import { BASE_URL,EMPLOYEE_WORKSHOP_EVALUATION, WORKSHOP_EVALUATION  } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IAnswer } from "models/EmployeeWorkshopEvaluation";
 
export async function getWorkshopEvaluation(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_EVALUATION + params);
  return response.data;
}

export async function getEmployeeWorkshopEvaluation(params: string = "") {
  const response = await axios.get(BASE_URL + EMPLOYEE_WORKSHOP_EVALUATION + params);
  return response.data;
}

export async function addEmployeeEvaluation(id: string) {
  const response = await axios.post(BASE_URL + EMPLOYEE_WORKSHOP_EVALUATION + '?workshopId=' + id);
  return response.data;
};

export async function addEmployeeAnswer(data: IAnswer, id: string) {
  const response = await axios.post(BASE_URL + EMPLOYEE_WORKSHOP_EVALUATION + '/addanswer?workshopId=' + id, data);
  return response.data;
};

export async function updateElapsedTime(id: string) {
  const response = await axios.patch(BASE_URL + EMPLOYEE_WORKSHOP_EVALUATION + '/' + id);
  return response.data;
};

export async function updateEvaluationStatus(id: string) {
  const response = await axios.patch(BASE_URL + EMPLOYEE_WORKSHOP_EVALUATION + '/employeefinishevaluation?id=' + id);
  return response.data;
};

export async function unfinishEvaluation(id: string) {
  const response = await axios.patch(BASE_URL + EMPLOYEE_WORKSHOP_EVALUATION + '/unfinishevaluation?id=' + id);
  return response.data;
};

export async function resetEvaluation(id: string) {
  const response = await axios.patch(BASE_URL + EMPLOYEE_WORKSHOP_EVALUATION + '/resetevaluation?id=' + id);
  return response.data;
};

export const EmployeeWorkshopEvaluationCells: HeadCell[] = [

  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "T_title",
  },
  {
    id: "timeToComplete",
    numeric: true,
    disablePadding: false,
    label: "T_time_to_complete",
  },
  {
    id: "numberOfQuestions",
    numeric: false,
    disablePadding: false,
    label: "T_number_of_questions",
  },
  {
    id: "completed",
    numeric: false,
    disablePadding: false,
    label: "T_status",
  },
  {
    id: "id",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  }
];